import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutConfigService } from '../../services/layout-config.service';
import { ILayoutConfig } from '../../interfaces/layout-config';
import { SignalRService } from 'projects/authentication/src/app/services/signal-r.service';

@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  public config: ILayoutConfig;

  constructor(private layoutConfigService: LayoutConfigService, private signalRServices: SignalRService, private cdr: ChangeDetectorRef) {
    this.config = {
      imageKey: 'summary',
      imageType: 'icon',
      title: 'summary',
      subtitle: '',
    };
  }

  /**
   * init app
   */
  public ngOnInit(): void {
    this.layoutConfigService.layoutChange.subscribe(
      (config: ILayoutConfig) => {
        this.config = config;
        this.cdr.detectChanges();
      },
      () => {},
    );
    this.signalRServices.loggedUser();
  }

  /**
   * ngOnDestroy
   */
  public ngOnDestroy(): void {
    this.signalRServices.disconnectLogin();
  }
}
